import { createComponent } from 'react-fela'

import { breakpoints, colors } from '../constants/theme'

const Container = props => ({
  width: '100%',
  height: props.height,
  flex: props.flex,
  marginLeft: 'auto',
  marginRight: 'auto',
  color: props.color || colors.text,
  justifyContent: props.center && 'center',
  ['@media (min-width: ' + breakpoints.min1920 + 'px)']: {
    width: 1404
  },
  ['@media (min-width: ' + breakpoints.min1440 + 'px)']: {
    width: 1170
  },
  ['@media (min-width: ' + breakpoints.min1024 + 'px)']: {
    width: 936,
    paddingLeft: 0,
    paddingRight: 0
  },
  ['@media (min-width: ' + breakpoints.min480 + 'px)']: {
    paddingLeft: props.noPadding ? 0 : '5%',
    paddingRight: props.noPadding ? 0 : '5%'
  },
  ['@media (max-width: ' + (breakpoints.min480 - 1) + 'px)']: {
    paddingLeft: props.noPadding ? 0 : 15,
    paddingRight: props.noPadding ? 0 : 15
  }
})

export default createComponent(Container, 'div', [
  'data-scroll-effect',
  'data-scroll-offset'
])



// WEBPACK FOOTER //
// ../components/Container.js